var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 7C50.464 7 63 19.536 63 35C63 50.464 50.464 63 35 63C19.536 63 7 50.464 7 35C7 19.536 19.536 7 35 7ZM49.1614 23.7678C48.1585 22.7949 46.6102 22.7504 45.5576 23.6128L45.3053 23.8473L30.9473 38.9589L24.7313 32.1541L24.4836 31.9146C23.4479 31.0315 21.8991 31.0454 20.8774 31.9983C19.8558 32.9512 19.7184 34.5101 20.5068 35.6239L20.7233 35.8925L30.8702 47L49.2401 27.6643L49.4617 27.4001C50.2716 26.3021 50.1644 24.7408 49.1614 23.7678Z",
    fill: "#1DAB98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check-circle-green.cf9962d7.svg";
export { ForwardRef as ReactComponent };